import type { BlockPlugin } from "./types";

/**
 * Block type registry. The engine looks up plugin for each `type`
 * HERE; adding a new type is `registry.register(plugin)` without touching
 * the engine. Enables generic learning platform capabilities.
 */
export class BlockRegistry {
  private readonly plugins = new Map<string, BlockPlugin>();

  /** Registers plugin. Throws if `type` already exists (avoids overwriting types). */
  register(plugin: BlockPlugin): this {
    if (this.plugins.has(plugin.type)) {
      throw new Error(`BlockRegistry: tipo duplicado "${plugin.type}"`);
    }
    this.plugins.set(plugin.type, plugin);
    return this;
  }

  /** Registers multiple at once. */
  registerAll(plugins: readonly BlockPlugin[]): this {
    for (const p of plugins) {
      this.register(p);
    }
    return this;
  }

  get(type: string): BlockPlugin | undefined {
    return this.plugins.get(type);
  }

  has(type: string): boolean {
    return this.plugins.has(type);
  }

  /** List of registered types (for authoring editor: "insert block"). */
  types(): string[] {
    return [...this.plugins.keys()];
  }
}
